import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, Dimensions, Button, Alert, Platform } from 'react-native';
import Amplify, { Auth } from 'aws-amplify';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Linking } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import LoginButtonInput from '../components/LoginButtonInput';
import LoginButton from '../components/LoginButton';
import SignUpButton from '../components/SignUpButton';
import mainIcon from '../assets/uploadifierSymbol.png';
import { ScrollView } from 'react-native-gesture-handler';
import validate from 'validate.js';


export default function ResetPassword({ navigation }) {
  //var country_code = "+1" ;
  var username; 

  const [OTP, setOTP] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  var accountnullcaseCounter = 0

  async function login() {
    try {
      await Auth.signIn(username, password);
      console.log('Authentication Success, User has logged in properly');
      updateAuthState('loggedIn');
      
      
    } catch (error) {
      console.log(' Error signing in...', error);
    }
  }
  async function resendConf() {
    console.log("Username is "+ email)
    await Auth.forgotPassword(email);
    //await Auth.signUp({ username, password, attributes: { email, phone_number } });
      console.log(' resent conf code for username '+ username);
      console.log(' resent conf code for email '+ email);
      console.log(' resent conf code for OTP '+ OTP);
      console.log(' resent conf code for Password '+ password);
      //navigation.navigate('ConfirmCreateAccount');
  }
  
  async function confirmForgotPassword(){
    try{

    if (password === ''){
        
      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        console.log('password is null')
        Alert.alert("Please enter a password");
        }
      if (Platform.OS === 'web'){
        console.log('password is null')
        alert("Please enter a password");
        }
      }

    if (password !== ''){
      await  Auth.forgotPasswordSubmit(email,OTP,password)
      console.log("new password request sumbmitted");
      navigation.navigate('Login')
      }
    }

    catch (error){
      console.log(' Error resetting PW...', error);
      console.log(error.name);

      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        if (error.name === 'InvalidParameterException'){
          Alert.alert('include at least 1 uppercase letter 1 lowercase letter and 1 number')
          Alert.alert('Password needs to be at least 8 Characters and')
        }
      }
      if (Platform.OS === 'web'){
        if (error.name === 'InvalidParameterException'){
        alert('Password needs to be at least 8 Characters and include at least 1 uppercase letter 1 lowercase letter and 1 number')
        }
      }
    

      if (Platform.OS === 'android' || Platform.OS === 'ios'){
        if (error.name === 'InvalidPasswordException'){
          Alert.alert('include at least 1 uppercase letter 1 lowercase letter and 1 number')
          Alert.alert('Password needs to be at least 8 Characters and')
        }
      }
      if (Platform.OS === 'web'){
        if (error.name === 'InvalidPasswordException'){
        alert('Password needs to be at least 8 Characters and include at least 1 uppercase letter 1 lowercase letter and 1 number')
        }
      }

    }
  
  
  }
   


    return (
    <SafeAreaView style={styles.safeAreaContainer}>
      <View style={styles.container}>
        <Text style={styles.title}>Enter your email address, then select send code</Text>
        <LoginButtonInput
          value={email}
          onChangeText={text => setEmail(text)}
          leftIcon="email"
          placeholder="Enter email address"
          autoCapitalize="none"
          keyboardType="email-address"
          textContentType="emailAddress"
        />

        <SignUpButton 
          title="Send Code to email" 
          onPress={resendConf} 
        />
        <Text style={styles.title}>When received</Text>
        <Text style={styles.title}>enter the 6 digit code sent to your email below</Text>
         <LoginButtonInput
          value={OTP}
          onChangeText={text => setOTP(text)}
          leftIcon="numeric"
          placeholder="Enter verification code"
          keyboardType="numeric"
        />

        <LoginButtonInput
          value={password}
          onChangeText={text => setPassword(text)}
          leftIcon="lock"
          placeholder="Enter New password"
          autoCapitalize="none"
          autoCorrect={false}
          secureTextEntry
          textContentType="password"
        />

        

        <LoginButton 
          title="Submit new password" 
          onPress={confirmForgotPassword}
        />

        <LoginButton 
          title="Take me back to Login" 
          onPress={() => navigation.navigate("Login")}
        />

          

        <View style={styles.footerButtonContainer}>        
         
        </View>
        
      </View>
    </SafeAreaView>
  );
}



const styles = EStyleSheet.create({
  column: {
    width: '80%'                                    // 80% of screen width
  },
  text: {
    color: '$textColor',                            // global variable $textColor
    fontSize: '1.5rem'                              // relative REM unit
  },
      safeAreaContainer: {
        flex: 1,
        backgroundColor: 'white'
      },
      phone: {
        backgroundColor: '#f9f9f9',
        borderRadius: 25,
        flexDirection: 'row',
        padding: '.9rem',
        marginVertical: '.25rem',
        width: '20rem',
        height: '3rem',
        fontSize: '1.15rem',
        color: '#101010'
      },
      container: {
        flex: 1,
        alignItems: 'center'
      },
      title: {
        fontSize: 20,
        //color: '#202020',
        color: "mediumblue",
        fontWeight: '500',
        marginVertical: 15
      },
      footerButtonContainer: {
        marginVertical: 15,
        justifyContent: 'center',
        alignItems: 'center'
      },
      warningText: {
        color: '$textColor',
        //fontSize: 18,
        //fontWeight: '600',
        width: '75%',
        height: '100%',
        fontSize: '.8rem'
      },
      warningTextScroll: {
        color: '$textColor',
        //fontSize: 18,
        //fontWeight: '600',
        width: '90%',
        height: '65%',
        fontSize: '1rem',
      },
      termsText: {
        color: 'mediumblue',
        fontSize: 18,
        fontWeight: '600',
        marginVertical: 10,
        width: '90%'
      }
    });

